import type { DatabaseDialect } from '@/types'
import type { DialectAdapter } from './dialectTypes'
import { postgresqlDialect } from './dialects/postgresqlDialect'
import { mysqlDialect, mariadbDialect } from './dialects/mysqlDialect'
import { sqlServerDialect } from './dialects/sqlServerDialect'
import { oracleDialect } from './dialects/oracleDialect'
import { sqliteDialect } from './dialects/sqliteDialect'

const REGISTRY: Record<DatabaseDialect, DialectAdapter> = {
  postgresql: postgresqlDialect,
  mysql:      mysqlDialect,
  mariadb:    mariadbDialect,
  sqlserver:  sqlServerDialect,
  oracle:     oracleDialect,
  sqlite:     sqliteDialect,
}

export function getDialectAdapter(dialect: DatabaseDialect): DialectAdapter {
  return REGISTRY[dialect] ?? postgresqlDialect
}

export const ALL_DIALECTS: { value: DatabaseDialect; label: string }[] = [
  { value: 'postgresql', label: postgresqlDialect.label },
  { value: 'mysql',      label: mysqlDialect.label },
  { value: 'mariadb',    label: mariadbDialect.label },
  { value: 'sqlserver',  label: sqlServerDialect.label },
  { value: 'oracle',     label: oracleDialect.label },
  { value: 'sqlite',     label: sqliteDialect.label },
]

export type { DialectAdapter }
